/**
 * Tiny className joiner. Skips falsy values. Avoids pulling in `clsx` or
 * `tailwind-merge` until the component count justifies it.
 */
export function cn(...classes: Array<string | undefined | null | false>): string {
  return classes.filter(Boolean).join(' ');
}
